import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const STATE_PROVINCE_BASE_PATH = '/StateProvince';

export const stateProvinceEndpoints = {
  list: () => buildEndpoint(STATE_PROVINCE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${STATE_PROVINCE_BASE_PATH}/:id`, { id }),
} as const;

export default stateProvinceEndpoints;
